// Pausa por inactividad (#1583). Decisiones puras, sin React ni estado.
//
// Cubre R7, R25, R26, R27 y R28 — .claude/specs/1583-promo-octubre/
//
// El back dice si la cuenta está en pausa con `access.code === "inactividad"`
// (`billing.access.access_state`); `access.pausa.estado` distingue pausada,
// revisando y reactivada. `/me` NUNCA trae el instante en que se reactiva
// (v2, R15): el front no puede mostrar plazos ni contar nada.
import { needsProfile } from "../components/routes/ProfileRequiredGate";
import { instanteChile } from "./trial-fecha";

export const CODE_INACTIVIDAD = "inactividad";

// Hay un corte vigente por inactividad en el `/me` que tenemos.
export const pausaBloquea = (user) => {
  const access = user?.access;
  return Boolean(access && access.permite === false && access.code === CODE_INACTIVIDAD);
};

// Qué pantalla de pausa corresponde dibujar: "pausada" | "revisando" | null.
// `bloqueoVivo`: llegó un 403 con code inactividad a mitad de sesión y el `/me`
// guardado puede estar viejo (todavía dice que sí).
//  - Términos pendientes va primero (R26): con ellos la pausa espera.
//  - Si el `/me` dice que el corte es otro (demo vencida, pago vencido), manda
//    ese: sin promo, una demo vencida gana sobre la pausa (R14 del back) y
//    `SuscripcionGate` dibuja su pantalla; nunca dos capas.
export const estadoPausaVisible = (user, bloqueoVivo = false) => {
  if (!user) return null;
  if (user.tos_needs_acceptance) return null;
  const access = user.access;
  if (access && access.permite === false && access.code !== CODE_INACTIVIDAD) return null;
  if (pausaBloquea(user)) {
    return access.pausa?.estado === "revisando" ? "revisando" : "pausada";
  }
  return bloqueoVivo ? "pausada" : null;
};

// "Estás en revisión" según el /me (la pantalla local también la fuerza al
// apretar el botón, sin esperar otra lectura).
export const enRevision = (user) => estadoPausaVisible(user) === "revisando";

// R28: el aviso de "reactivada" se muestra una vez, cuando no hay otro gate de
// alta dibujado (Términos, celular/perfil) ni pausa vigente.
export const avisoReactivadaVisible = (user) => {
  if (!user) return false;
  const access = user.access;
  if (!access || access.permite === false) return false;
  if (access.pausa?.aviso_reactivada !== true) return false;
  if (user.tos_needs_acceptance) return false;
  return !needsProfile(user);
};

// R7: durante la promo, la demo cuenta hasta la fecha más tardía entre
// `trial_ends_at` y `access.promo_hasta` (AAAA-MM-DD de Chile, 23:59:59), igual
// que `access.dias_restantes` en el back (R4). Sin `trial_ends_at` la demo no
// empezó y se deja tal cual (el aviso dice "parte con tu primer documento").
// Devuelve el mismo valor que recibió o el instante ISO del fin de la promo.
export const terminoEfectivoDemo = (trialEndsAt, promoHasta) => {
  if (!trialEndsAt || !promoHasta) return trialEndsAt || null;
  const finPromo = instanteChile(promoHasta, "23:59");
  // `instanteChile` trae HH:MM; el segundo 59 se suma aparte.
  const finPromoMs = new Date(finPromo).getTime() + 59 * 1000;
  return new Date(trialEndsAt).getTime() >= finPromoMs ? trialEndsAt : new Date(finPromoMs).toISOString();
};
